import { State } from "../../types";
import { sortValueKeys } from "../util";

export type MoveToNextDataPointAction = Readonly<{
  type: "MOVE TO NEXT DATA POINT";
}>;

export const moveToNextDataPoint = (state: State, _action: MoveToNextDataPointAction): State => {
  const sortedKeys = sortValueKeys(
    Object.keys(state.values),
    state.taxonomy,
  );
  const index = sortedKeys.indexOf(state.activeValue);
  if (index >= sortedKeys.length - 1) {
    return state;
  }
  return {
    ...state,
    activeValue: sortedKeys[index + 1],
  };
};
